module.exports = __webpack_public_path__ + "static/media/img-3c16c0d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/healthfully-logo.png
// module id = 5287
// module chunks = 39